import React from "react"

import DineroFactory from "dinero.js"

import {
  ActionWrapper,
  CartItemContainer,
  InfoWrapper,
  ItemDetails,
  ItemImage,
  ItemName,
  ItemPrice
} from "./CartItem.styled"
import Money from "../../../../Money"
import { OrderRefund, RefundGiftCardProduct } from "lib/types/generated/graphql-types"
import SecondaryButton from "../../../../Ui/Buttons/SecondaryButton"
import { ButtonWrapper } from "../Shared.styled"
import { useMutation } from "@apollo/client"
import UPDATE_REFUND from "../../../../../graphql/mutations/order/refunds/UpdateRefund"
import { getRefundInput } from "../Helpers/helpers"
import { handleErrorMessages } from "helpers/errors"
import { ReactComponent as GiftCardIcon } from "images/icons/gift-card.svg"

type Props = {
  item: RefundGiftCardProduct
  currencyCode?: string
  refund: OrderRefund
  refetch: () => void
}

const GiftCardProductItem = ({ item, currencyCode, refund, refetch, ...props }: Props) => {
  const [updateRefund, { loading }] = useMutation(UPDATE_REFUND, {
    onCompleted: () => refetch(),
    onError: (error) => {
      handleErrorMessages(error)
    }
  })

  const removeGiftCardProductFromRefund = () => {
    return updateRefund({
      variables: {
        refundId: refund.id,
        input: {
          ...getRefundInput(refund),
          giftCardProducts: refund.giftCardProducts.filter(
            (gcp) => gcp.giftCardProductId !== item.giftCardProductId
          )
        }
      }
    })
  }

  return (
    <CartItemContainer {...props}>
      <InfoWrapper>
        <ItemImage>
          <GiftCardIcon />
        </ItemImage>
        <ItemDetails>
          <ItemName>Gift card</ItemName>
          <ItemPrice>
            <Money
              amount={Number(item?.priceAmount ?? 0)}
              currencyUnit={currencyCode as DineroFactory.Currency}
            />
          </ItemPrice>
        </ItemDetails>
      </InfoWrapper>

      <ActionWrapper $loading={loading}>
        <span>
          <b>Amount to be refunded:</b>{" "}
          <Money
            amount={Number(item?.priceAmount ?? 0)}
            currencyUnit={currencyCode as DineroFactory.Currency}
          />
        </span>
        <hr />
        <ButtonWrapper>
          <SecondaryButton handleClick={removeGiftCardProductFromRefund}>Undo</SecondaryButton>
        </ButtonWrapper>
      </ActionWrapper>
    </CartItemContainer>
  )
}

export default GiftCardProductItem
